import {
  Arrange,
  Container,
  IconButton,
  SvgComment,
  SvgExternalLink,
  SvgShare,
  TextButton,
  Tooltip,
} from '@loomhq/lens';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestVideoPlayerPause } from 'actions/videoPlayer';
import { LOOM_URI } from 'constants/routes';
import { videoPlayerShowComments } from 'creators/videoPlayer';
import { goToNewTab } from 'utilities/url';

import { selectCommentReplyCount } from 'selectors/comments';
import { selectCurrentUser } from 'selectors/user';
import { selectCommentsEnabled } from 'selectors/video';
import {
  selectPlayerTime,
  selectVideo,
  selectVideoDuration,
} from 'selectors/videoPlayer';

import { EmbedContext } from 'components/embed-video';
import CommentFetch from 'components/ui-components/comment-fetch';
import SocialMediaShareButton from 'components/ui-components/share-dropdown-menu/SocialMediaShareButton';

const EmbedActionButtons = () => {
  const video = useSelector(selectVideo);
  const currentTime = useSelector(selectPlayerTime);
  const videoDuration = useSelector(selectVideoDuration);

  const currentUser = useSelector(selectCurrentUser);
  const currentUserIsOwner = video.current_user_is_owner;

  const timeToPutInUrl = currentTime == videoDuration ? 0 : currentTime;

  const shareUrl = `${LOOM_URI}/share/${video.id}?t=${parseInt(
    timeToPutInUrl,
    10
  )}`;

  const commentsEnabled = useSelector(selectCommentsEnabled);
  const commentReplyCount = useSelector(selectCommentReplyCount);

  const dispatch = useDispatch();

  const commentClick = () => {
    dispatch(videoPlayerShowComments());
  };

  const watchOnLoomClick = () => {
    dispatch(requestVideoPlayerPause());
    goToNewTab(shareUrl);
  };

  return (
    <EmbedContext.Consumer>
      {({ hideShare }) => (
        <Container
          paddingX="small"
          radius="medium"
          backgroundColor="var(--videoOverlay)"
        >
          <Arrange gap="xsmall" height={4.5}>
            {commentsEnabled && (
              <CommentFetch>
                <Tooltip content="View Comments" placement="bottomCenter">
                  <TextButton
                    data-testid="overlay-comments-button"
                    altText="View Comments"
                    icon={<SvgComment />}
                    onClick={commentClick}
                  >
                    {commentReplyCount || 0}
                  </TextButton>
                </Tooltip>
              </CommentFetch>
            )}
            {!hideShare && (
              <Tooltip content="Share" placement="bottomCenter">
                <SocialMediaShareButton
                  user={currentUser}
                  video={video}
                  isOwner={currentUserIsOwner}
                  buttonElement={onClickParam => (
                    <div>
                      <IconButton
                        altText="Share"
                        onClick={onClickParam}
                        icon={<SvgShare />}
                      />
                    </div>
                  )}
                />
              </Tooltip>
            )}
            <Tooltip content="Watch on Loom" placement="bottomCenter">
              <IconButton
                data-testid="overlay-watch-on-loom-button"
                altText="Watch on Loom"
                onClick={watchOnLoomClick}
                icon={<SvgExternalLink />}
              />
            </Tooltip>
          </Arrange>
        </Container>
      )}
    </EmbedContext.Consumer>
  );
};

export default EmbedActionButtons;
